var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    class: _vm.$style.errorWrapper
  }, [_vm.img ? _c('div', {
    class: _vm.$style.imageWrapper
  }, [_c(_setup.SImageLazy, {
    class: _vm.$style.image,
    attrs: {
      "src": _vm.img,
      "fade": "",
      "alt": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.$style.title
  }, [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]), _vm._v(" "), _c('div', {
    class: _vm.$style.text
  }, [_vm._v("\n    " + _vm._s(_vm.text) + "\n  ")])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };